import { Thumbnail, ThumbnailImage, Typography } from "@backpac/monica";

export const TrackFlag = ({
  coverImageUrl,
  name,
  className,
}: {
  coverImageUrl: string;
  name: string;
  className?: string;
}) => {
  return (
    <div className="flex flex-row items-center gap-4">
      <Thumbnail variant="square" className={className}>
        <ThumbnailImage src={coverImageUrl} alt={name} />
      </Thumbnail>
      <Typography size="xs" color="textPrimary">
        {name}
      </Typography>
    </div>
  );
};
